module.exports = new __parcel__URL__("search-no-results-old.10b14394.svg").toString();